"use strict";

/** PubSub Object Literal. */
window.pubsub = {
    /**
    * Actions store for all events and callbacks
    */
    actions: [],
    
    /**
    * Store a callback in an event
    * @param {string} e - A custom event name
    * @param {callback} cb - A callback function
    */
    on: function on(e, cb) {
        if (typeof this.actions[e] === 'undefined') {
            this.actions[e] = [cb];
        } else {
            this.actions[e].push(cb);
        }
        
        return this.actions;
    },
    
    /**
    * Remove a callback from an event
    * @param {string} e - A custom event name
    * @param {callback} [cb] - An optional callback function
    */
    off: function off(e, cb) {
        var _this = this;
        
        if (this.actions[e]) {
            if (!cb) {
                delete this.actions[e];
            } else {
                this.actions[e].forEach(function (fn, i) {
                    if (fn === cb) {
                        _this.actions[e].splice(i, 1);
                    }
                });
            }
        }
    },
    
    /**
    * Trigger an event
    * @param {string} e - A custom event name
    * @param {Object} [d] - Optional data packet
    */
    trigger: function trigger(e, d) {
        var data = d || {};
        
        if (this.actions[e]) {
            this.actions[e].forEach(function (cb) {
                return cb(data);
            });
        }
    }
};